{
  "nl": {
    "folders": {
      "breadcrumb": {
        "contentCount": "{count} inhoud | {count} inhoud",
        "overview": "Overzicht",
        "showPath": "Mappad weergeven",
        "up": "Eén niveau omhoog"
      },
      "buttons": {
        "back": "Terug",
        "clearDiscarded": "Prullenbak legen",
        "createFolder": "Map aanmaken",
        "deleteFolder": "Naar prullenbak verplaatsen",
        "moveFolder": "Map verplaatsen",
        "renameFolder": "Map hernoemen",
        "renameItem": "Hernoemen"
      },
      "emptyTrashDialog": {
        "button": "Legen",
        "text": "Deze actie kan niet ongedaan worden gemaakt. Alle inhoud in de prullenbak wordt permanent verwijderd.",
        "title": "Prullenbak definitief legen?"
      },
      "confirmDeleteDialog": {
        "button": "Ja, verwijderen",
        "text": "Verwijderde inhoud kan niet worden hersteld.",
        "title": "Inhoud definitief verwijderen"
      },
      "discarded": {
        "alert": {
          "text": "Van werkblad tot audio-opname - wanneer je materialen verwijdert, komen ze hier in de prullenbak terecht en worden ze <strong>na 30 dagen</strong> definitief verwijderd."
        },
        "hints": {
          "noItems": {
            "emptyTable": "Er is momenteel geen inhoud in je prullenbak."
          }
        },
        "subline": "Verwijderde materialen en mappen blijven <strong>30 dagen</strong> in de prullenbak. Tot die tijd kun je ze herstellen, daarna worden ze definitief verwijderd."
      },
      "headings": {
        "discarded": "Prullenbak",
        "search": "Doorzoek je opslag",
        "searchResults": "{count} zoekresultaten"
      },
      "hints": {
        "emptySubfolder": {
          "emptyTable": "Er is momenteel geen inhoud in deze map.",
          "text": "Je kunt eenvoudig inhoud uit andere mappen naar deze map verplaatsen of direct nieuwe inhoud en submappen hier aanmaken.",
          "title": "Deze map is leeg"
        },
        "noItems": {
          "addContent": "Nieuwe inhoud aanmaken",
          "emptyTable": "Er is nog geen inhoud in je opslag.",
          "text": "Organiseer alle inhoud en materialen die je hebt gemaakt in mappen en vind ze gemakkelijk terug.",
          "title": "Jouw opslag",
          "videoId": "1154655532",
          "videoTitle": "Tutorial: Je inhoud organiseren"
        },
        "share": {
          "text": "Deel en gebruik materiaal met collega's. Via remix kunnen ze het kopiëren, aanpassen en gebruiken.",
          "title": "Delen is zorgen: materiaal samen gebruiken"
        }
      },
      "labels": {
        "foldersNew": "Map aanmaken"
      },
      "bulk": {
        "actionsDropdown": "Inhoud ...",
        "clearSelection": "Selectie opheffen",
        "modals": {
          "delete": {
            "description": "De geselecteerde inhoud wordt naar de prullenbak verplaatst. Je kunt inhoud binnen 30 dagen uit de prullenbak herstellen.",
            "heading": "Naar prullenbak verplaatsen",
            "singleItemDescription": "Binnen 30 dagen kun je inhoud uit je prullenbak herstellen.",
            "submit": "Ja, naar prullenbak"
          },
          "move": {
            "heading": "Inhoud verplaatsen"
          }
        },
        "moveToFolder": "Naar map verplaatsen",
        "selectedItems": "{count} inhoud geselecteerd | {count} inhoud geselecteerd",
        "undiscardItems": "Herstellen"
      },
      "filter": {
        "customRange": "Periode instellen",
        "dateFrom": "Van",
        "dateTo": "Tot",
        "duration": "Periode",
        "items": "Materiaal en mappen",
        "last30Days": "Laatste 30 dagen",
        "last7Days": "Laatste 7 dagen",
        "lastYear": "Vorig jaar ({ year })",
        "thisYear": "Dit jaar ({ year })",
        "totalPeriod": "Gehele periode"
      },
      "links": {
        "trash": "Prullenbak bekijken"
      },
      "modals": {
        "createFolder": {
          "heading": "Map aanmaken"
        },
        "moveFolder": {
          "folder": "Map",
          "moveToNewFolder": "Naar nieuwe map verplaatsen",
          "newFolder": "Nieuwe map"
        },
        "renameFolder": {
          "heading": "Map hernoemen"
        }
      },
      "navbarTitle": "Mijn opslag",
      "search": {
        "placeholder": "Doorzoek mijn opslag..."
      },
      "subtitle": "Mijn opslag",
      "title": "Mijn opslag"
    }
  }
}
